// Warm the HTTP cache for the RushMid loading-screen art + menu theme during app
// init, at idle priority — so they're ready when the loading gate mounts WITHOUT
// competing with (or adding to) the app's own startup. Fire-and-forget, runs once.
import { bustCache } from '../components/RushMid/render/battleAssetVersion';
import { soundUrl } from './audioEngine';
import { getAsset } from './assetStore';

let started = false;

type IdleWindow = Window & {
  requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => void;
};

export function prefetchLoadingAssets(): void {
  if (started || typeof window === 'undefined') return;
  started = true;
  // the loading-screen art goes FIRST and immediately: a deep link can land the user on
  // the loading gate within the first second of the app's life, before any idle slot
  void getAsset(bustCache('/battle/rush_mid_loading.webp')).catch(() => undefined);
  const run = () => {
    void getAsset(soundUrl('menu_theme')).catch(() => undefined);
  };
  const w = window as IdleWindow;
  if (w.requestIdleCallback) w.requestIdleCallback(run, { timeout: 5000 });
  else window.setTimeout(run, 2000);
}
